export default __webpack_public_path__ + "img/revive-b6e98558.png";